/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { CatalogActivityDailyRowDTOFromJSON, } from '../models/index';
/**
 *
 */
export class CatalogActivityControllerApi extends runtime.BaseAPI {
    /**
     */
    async listCatalogActivityDailyRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'].toISOString().substring(0, 10);
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/catalog-activity/daily`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CatalogActivityDailyRowDTOFromJSON));
    }
    /**
     */
    async listCatalogActivityDaily(requestParameters = {}, initOverrides) {
        const response = await this.listCatalogActivityDailyRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
